import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import TenableWebappConfigListing from './TenableWebappConfigListing'
import TenableWebappCredentialsForm from './TenableWebappCredentialsForm'

export default function TenableWebappPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={TenableWebappCredentialsForm}
            PullConfigListingView={TenableWebappConfigListing}
        />
    )
}